/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleNextPointDto } from './equipment-schedule-next-point-dto';
import { EquipmentScheduleLastCommandDto } from './equipment-schedule-last-command-dto';
import { EquipmentScheduleAssignmentItemResponseDto } from './equipment-schedule-assignment-item-response-dto';


export interface EquipmentSchedulesCardResponseDto { 
    equipmentId?: string;
    regular?: EquipmentScheduleAssignmentItemResponseDto;
    calendars?: Array<EquipmentScheduleAssignmentItemResponseDto> | null;
    nextPoints?: Array<EquipmentScheduleNextPointDto> | null;
    lastCommand?: EquipmentScheduleLastCommandDto;
}

